import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "normalize.css";
import Vant from "vant";
import "vant/lib/index.css";
import VueKeepScrollPosition from "vue-keep-scroll-position";

Vue.use(Vant);
Vue.use(VueKeepScrollPosition);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
